// Fields
export {MaxValueFieldControlled} from "./src/components/fields/MaxValueFieldControlled";
export {InputField} from "./src/components/fields/InputField";
export {TextareaField} from "./src/components/fields/TextareaField";
export {PhoneFieldControlled} from "./src/components/fields/PhoneFieldControlled";
export {SelectFieldControlled} from "./src/components/fields/SelectFieldControlled";
export {SelectCreatableFieldControlled} from "./src/components/fields/SelectCreatableFieldControlled";
export {SelectRangeFieldControlled} from "./src/components/fields/SelectRangeFieldControlled";
export {CalendarSliderControlled} from "./src/components/fields/CalendarSliderControlled";

export type {SelectAsyncFieldControlledProps} from "./src/components/fields/SelectAsyncFieldControlled";

//  Inputs
export {RadioControlled} from "./src/components/inputs/RadioControlled";
export {RadioGroupControlled} from "./src/components/inputs/RadioGroupControlled";
export {CheckboxControlled} from "./src/components/inputs/CheckboxControlled";
export {SliderWithRangeControlled} from "./src/components/inputs/SliderWithRangeControlled";
export {CheckBoxGroupControlled} from "./src/components/inputs/CheckBoxGroupControlled";
export {SwitcherControlled} from "./src/components/inputs/SwitcherControlled";
export {SelectAsyncFieldControlled} from "./src/components/fields/SelectAsyncFieldControlled";
import {Controller, Form, FormProvider, useController, useFieldArray, useForm, useFormContext, useFormState, useWatch} from "react-hook-form";

/**
 * Import workarounds (webpack causes issues with current monorepo config, need to import hooks from this package
 * instead directly from lib)
 */
export const useFormRHF = useForm;
export const FormRHF = Form;
export const useControllerRHF = useController;
export const ControllerRHF = Controller;
export const useFormContextRHF = useFormContext;
export const FormProviderRHF = FormProvider;
export const useWatchRHF = useWatch;
export const useFormStateRHF = useFormState;
export const useFieldArrayRHF = useFieldArray;
// Fields
export {MaxValueFieldControlled} from "./src/components/fields/MaxValueFieldControlled";
export {InputField} from "./src/components/fields/InputField";
export {TextareaField} from "./src/components/fields/TextareaField";
export {PhoneFieldControlled} from "./src/components/fields/PhoneFieldControlled";
export {SelectFieldControlled} from "./src/components/fields/SelectFieldControlled";
export {SelectCreatableFieldControlled} from "./src/components/fields/SelectCreatableFieldControlled";
export {SelectRangeFieldControlled} from "./src/components/fields/SelectRangeFieldControlled";
export {CalendarSliderControlled} from "./src/components/fields/CalendarSliderControlled";

export type {SelectAsyncFieldControlledProps} from "./src/components/fields/SelectAsyncFieldControlled";

//  Inputs
export {RadioControlled} from "./src/components/inputs/RadioControlled";
export {RadioGroupControlled} from "./src/components/inputs/RadioGroupControlled";
export {CheckboxControlled} from "./src/components/inputs/CheckboxControlled";
export {SliderWithRangeControlled} from "./src/components/inputs/SliderWithRangeControlled";
export {CheckBoxGroupControlled} from "./src/components/inputs/CheckBoxGroupControlled";
export {SwitcherControlled} from "./src/components/inputs/SwitcherControlled";
export {SelectAsyncFieldControlled} from "./src/components/fields/SelectAsyncFieldControlled";
import {Controller, Form, FormProvider, useController, useFieldArray, useForm, useFormContext, useFormState, useWatch} from "react-hook-form";

/**
 * Import workarounds (webpack causes issues with current monorepo config, need to import hooks from this package
 * instead directly from lib)
 */
export const useFormRHF = useForm;
export const FormRHF = Form;
export const useControllerRHF = useController;
export const ControllerRHF = Controller;
export const useFormContextRHF = useFormContext;
export const FormProviderRHF = FormProvider;
export const useWatchRHF = useWatch;
export const useFormStateRHF = useFormState;
export const useFieldArrayRHF = useFieldArray;
